module.exports = __webpack_public_path__ + "static/media/art44.52bf2526.jpg";